import { Injectable } from '@angular/core';
import moment  from 'moment';
import 'moment-timezone';

@Injectable({
  providedIn: 'root',
})
export class ItalianDateService {
  constructor() {}

  /**
   * Converts a given Date object to its ISO string representation in Italian timezone.
   * @param date The Date object to convert.
   * @returns The ISO string representation of the date in Italian timezone.
   */
  public toItalianDateISO(dateInput: Date | null): string {
    if (!dateInput) {
      return moment.tz('Europe/Rome').startOf('day').locale("it").format();
    }

    return moment.tz({
      year: dateInput.getFullYear(),
      month: dateInput.getMonth(),
      day: dateInput.getDate(),
    }, 'Europe/Rome').locale("it").format();
  }

  /* istanbul ignore next */
  /**
   *
   * @returns The current date in Italian timezone as a Date object.
   */
  public getItalianDate(): Date {
    // Get the current time in Italy as a moment object
    const italianDateMoment = moment().tz('Europe/Rome');

    // Get everything to convert to a Date object
    const year = italianDateMoment.year();
    const month = italianDateMoment.month();
    const day = italianDateMoment.date();
    const hours = italianDateMoment.hour();
    const minutes = italianDateMoment.minute();
    const seconds = italianDateMoment.second();

    return new Date(year, month, day, hours, minutes, seconds);
  }

}
